import React from 'react';
import './PhotoSlider.css';
import journey01 from '../../images/journey/54.jpeg';
import journey1 from '../../images/journey/1.jpeg';
import journey7 from '../../images/journey/7.jpeg';
import journey18 from '../../images/journey/18.jpeg';
import journey3 from '../../images/journey/3.jpeg';
import journey4 from '../../images/journey/4.jpeg';
import journey02 from '../../images/journey/51.jpeg';
import journey5 from '../../images/journey/5.jpeg';
import journey6 from '../../images/journey/6.jpeg';
import journey2 from '../../images/journey/2.jpeg';
import journey19 from '../../images/journey/19.jpeg';
import journey8 from '../../images/journey/8.jpeg';
import journey9 from '../../images/journey/9.jpeg';
import journey10 from '../../images/journey/10.jpeg';
import journey11 from '../../images/journey/11.jpeg';
import journey12 from '../../images/journey/12.jpeg';
import journey20 from '../../images/journey/20.jpeg';
import journey21 from '../../images/journey/21.jpeg';
import journey13 from '../../images/journey/13.jpeg';
import journey14 from '../../images/journey/14.jpeg';
import journey15 from '../../images/journey/15.jpeg';
import journey17 from '../../images/journey/17.jpeg';





const JOURNEY_IMAGES = [
  journey01, 
  journey1,journey7,journey19, journey2, journey15,journey3, journey11, journey4, journey5,
  journey6, journey18, journey02, journey8, journey9, journey10,journey20,
   journey12, journey13, journey14, 
  journey17,    journey21,
].map((src) => ({ src, alt: 'Our journey' }));

const PhotoSlider = ({ images, speed, title }) => {
  const list = (images && images.length > 0 ? images : JOURNEY_IMAGES).map((item) =>
    typeof item === 'string' ? { src: item, alt: '' } : { src: item.src, alt: item.alt || '' }
  );
  const duplicated = [...list, ...list];
  const speedSec = speed != null ? speed : 35;
  const heading = title || 'Our Journey';

  return (
    <section className="photo-slider-wrap" aria-label="Photo gallery">
      <div className="photo-slider-header">
        <h2 className="photo-slider-title">{heading}</h2>
      </div>
      <div className="photo-slider-track" style={{ '--slider-speed': speedSec + 's' }}>
        <div className="photo-slider-inner">
          {duplicated.map((img, i) => (
            <div key={i} className="photo-slider-item">
              <img src={img.src} alt={img.alt || 'Slide ' + (i + 1)} loading="lazy" />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PhotoSlider;
